/** Time zone the customers API assumes when a customer has none. */
export const DEFAULT_TIMEZONE = 'UTC';

/**
 * IANA time zones offered on the customer screen: one per distinct North American clock (offset and
 * daylight-saving rule). A customer saved with another zone keeps it.
 */
export const TIMEZONE_OPTIONS: string[] = [
  DEFAULT_TIMEZONE,
  // United States
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Puerto_Rico',
  // Canada
  'America/St_Johns',
  'America/Halifax',
  'America/Toronto',
  'America/Winnipeg',
  'America/Regina',
  'America/Edmonton',
  'America/Vancouver',
  // Mexico
  'America/Cancun',
  'America/Mexico_City',
  'America/Hermosillo',
  'America/Tijuana',
];
